import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 7H11V13H17V7Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 3H21V17H7V3ZM9 5V15H19V5H9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 7.5V10.5H3V7.5H5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 12.5V15.5H3V12.5H5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 17.5V19H6.5V21H3V17.5H5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 19V21H8.5V19H11.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.5 19H16.5V21H13.5V19Z"}}]};

const FlipToFrontFilled = Vue.extend<IconProps>({
  name: 'FlipToFrontFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'flip-to-front-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FlipToFrontFilled;
